import { useEffect } from "react";
import { Reveal, Eyebrow } from "../lib/data";

const PageHero = ({ eyebrow, title, desc, pageTitle }) => {
  useEffect(() => {
    if (pageTitle) document.title = `${pageTitle} | MEDAS Stomatologie Timișoara`;
  }, [pageTitle]);

  return (
    <section className="pt-32 lg:pt-40 pb-14 lg:pb-16 bg-white medical-grid" data-testid="page-hero">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal className="max-w-3xl">
          <Eyebrow>{eyebrow}</Eyebrow>
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-[#2A2521] mt-3 leading-[1.08]">{title}</h1>
          {desc && <p className="text-[#6B5C43] mt-4 text-base md:text-lg leading-relaxed">{desc}</p>}
        </Reveal>
      </div>
    </section>
  );
};

export default PageHero;
